import { DataBean } from "../../DataBean";


export class HealthAssesmentResult extends DataBean {


    public async getHealthAssesmentResultCatalog(state:any,regexStr:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getHealthAssesmentResultCatalog_Number_String_Number_Number", [state,regexStr,page,recordsPerPage]);
    }


}